<template>
  <v-toolbar
    flat
    max-height="56"
    color="grey lighten-4"
  >
    <v-btn
      icon
      color="primary"
      @click.stop="$emit('close')"
    >
      <v-icon v-text="icons.close" />
    </v-btn>
    <v-spacer />
    <v-toolbar-title v-text="title" />
    <v-spacer />
    <v-btn
      icon
      color="primary"
      @click.stop="$emit('done')"
    >
      <v-icon v-text="icons.done" />
    </v-btn>
  </v-toolbar>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      title: {
        required: true,
        type: String,
      },
    },
  }
</script>
